import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const GTM_ID = 'GTM-N9F5JG8R';

// Injects Google Tag Manager exactly as Google specifies (head script + body noscript),
// but scoped to the public website only (this component is mounted inside the public Layout,
// never inside the private /portal app). SPA route changes are pushed to the dataLayer so
// Google Analytics records individual section views (Medicare, dental, vision, health plans...).
function injectGTM() {
  if (typeof window === 'undefined' || window.__gtmInjected) return;
  window.__gtmInjected = true;

  window.dataLayer = window.dataLayer || [];

  // 1) Code that Google asks to place as high in the <head> as possible
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', GTM_ID);

  // 2) Code that Google asks to place immediately after the opening <body> tag
  if (!document.getElementById('gtm-noscript')) {
    const noscript = document.createElement('noscript');
    noscript.id = 'gtm-noscript';
    noscript.innerHTML =
      `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" ` +
      `height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);
  }
}

export function GoogleTagManager() {
  const location = useLocation();
  const firstLoad = useRef(true);

  useEffect(() => {
    injectGTM();
  }, []);

  useEffect(() => {
    // The initial page view is already fired by gtm.js on load; only push
    // subsequent SPA navigations so each public section is tracked once.
    if (firstLoad.current) {
      firstLoad.current = false;
      return;
    }
    if (!window.dataLayer) return;
    window.dataLayer.push({
      event: 'page_view',
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}

export default GoogleTagManager;
